import React, {useEffect, useState} from 'react'
import ShowLink from "../../../common/ui/show-link";
import DesignDetails from "./design-details";
import {searchPods} from "../../../pod/services/pod-data-service";
import {searchQuotes} from "../../../common/services/quote-data-service";
import _ from 'lodash'
import {addSingleDesign, getSingleDesign, updateSingleDesign} from "../../services/design-data-service";
import ShowDesignDetail from "../common/show-design-detail";
import {useParams} from "react-router-dom";
import {searchThemes} from "../../../theme/services/theme-data-service";
import {searchTags} from "../../../common/services/tag-data-service";

const AddEditDesign = () => {
    const {designId} = useParams();
    const [isEditDesign, setIsEditDesign] = useState(false);
    const [saveInProgress, setSaveInProgress] = useState(false);
    const [initialStep, setInitialStep] = useState(true);
    const [designDetail, setDesignDetail] = useState(null);
    const [selectedPod, setSelectedPod] = useState(null);
    const [podList, setPodList] = useState(null);
    // const [quoteList, setQuoteList] = useState(null);
    const [themeList, setThemeList] = useState(null);
    const [allTags, setAllTags] = useState([]);

    useEffect(() => {
        getAllPodList();
        // getAllQuoteList();
        getAllThemeList();
        getTagsList();
    }, [initialStep]);

    useEffect(() => {
        if (!_.isEmpty(designId)) {
            getDesignById();
        }
    }, [designId]);

    const getDesignById = async () => {
        getSingleDesign(designId)
            .then(response => {
                const designDetailData = _.cloneDeep(response.data());
                designDetailData.id = designDetailData.id || designId;
                setDesignDetail(designDetailData);
                setIsEditDesign(true);
            });
    }

    const getAllPodList = async () => {
        const podListResult = await searchPods('');
        setPodList(podListResult);
    }

    const getTagsList = async () => {
        const tagsListResult = await searchTags('');
        setAllTags(tagsListResult);
    }

    const getAllThemeList = async () => {
        const themeListResult = await searchThemes('');
        setThemeList(_.orderBy(themeListResult, ['startText']));
    }

    const handleUpdateDesign = async () => {
        setSaveInProgress(true);
        const existingDesignDetail = {...designDetail};

        // console.log('Before Saving... existingDesignDetail: ', existingDesignDetail)

        await updateSingleDesign(existingDesignDetail);

        setSaveInProgress(false);
    }

    const handleCreateNewDesign = async () => {
        setSaveInProgress(true);
        const newDesignDetail = {...designDetail};
        const addedDesign: any = await addSingleDesign(newDesignDetail);

        newDesignDetail.id = addedDesign.id;
        setDesignDetail(newDesignDetail);

        setIsEditDesign(true);
        setSaveInProgress(false);
    }

    return (
        <>
            <div className="justify-center bg-gray-200 rounded dashboard-container">

                <div className="justify-start p-8">
                    <div className="items-center justify-start w-full mb-4">
                        <div className="flex justify-start items-center">
                            <div className="mr-2">
                                <ShowLink label="Back"
                                          url="/designs"/>
                            </div>
                            {designDetail &&
                                <ShowDesignDetail designDetail={designDetail}/>
                            }
                        </div>
                    </div>

                    <div>
                        <DesignDetails designDetail={designDetail}
                                       setDesignDetail={setDesignDetail}
                                       podList={podList}
                                       selectedPod={selectedPod}
                                       setSelectedPod={setSelectedPod}
                                       themeList={themeList}
                                       isEditDesign={isEditDesign}
                                       allTags={allTags}
                        />
                    </div>

                    <div className="m-2 pt-4">
                        {!isEditDesign && !saveInProgress &&
                            <button
                                className="button-small bg-green-500 hover:bg-green-200 hover:text-green-700"
                                onClick={handleCreateNewDesign}>
                                Create Design
                            </button>
                        }

                        {isEditDesign && !saveInProgress &&
                            <button
                                className="button-small bg-green-500 hover:bg-green-200 hover:text-green-700"
                                onClick={handleUpdateDesign}>
                                Update Design
                            </button>
                        }

                        {saveInProgress &&
                            <button
                                className="button-small-no-hover bg-gray-400 border-0 cursor-progress"
                                onClick={() => {
                                }}>
                                Saving Design ...
                            </button>
                        }
                    </div>

                </div>

            </div>
        </>
    )
}

export default AddEditDesign
